export default __webpack_public_path__ + "static/media/arc.9d558277.jpg";